import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useDictionary, useIsDesktop } from 'Hooks';
import { AccessibleClinic } from './AccessibleClinic';

interface IAddresses {
  addresses: {
    firstAddress: IAddress;
    secondAddress: IAddress;
  };
  isAccessible: boolean;
}

export interface IAddress {
  street: string;
  houseNumber: string;
  cityId: number | undefined;
}

export const Address = ({ addresses, isAccessible }: IAddresses) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage
    .therapy;

  const cities = useAppSelector(
    ({ generalOptions: { generalOptions } }) => generalOptions
  )?.cities;

  const findCity = (cityId: number | undefined) => {
    if (!cityId) return '';
    const city = cities?.find((city: any) => city.id === cityId)?.value;
    return city ? `, ${city}` : '';
  };

  return (
    <Stack gap='12px'>
      {isDesktop && (
        <Typography variant='body1'>{dictionary.address}</Typography>
      )}
      {addresses.firstAddress.street || addresses.secondAddress.street ? (
        <>
          {addresses.firstAddress.street && (
            <Typography variant='body3'>
              {addresses.firstAddress.street}{' '}
              {addresses.firstAddress.houseNumber || ''}
              {findCity(addresses.firstAddress.cityId)}
            </Typography>
          )}
          {addresses.secondAddress.street && (
            <Typography variant='body3'>
              {addresses.secondAddress.street}{' '}
              {addresses.secondAddress.houseNumber || ''}
              {findCity(addresses.secondAddress.cityId)}
            </Typography>
          )}
        </>
      ) : (
        <Typography variant='body3'>{dictionary.noData}</Typography>
      )}
      {isDesktop && isAccessible && <AccessibleClinic />}
    </Stack>
  );
};
